export default [
    {
        component: () => import(/* webpackChunkName: 'farmacia-supervisor' */ '@/views/farmacia/supervisor/Index'),
        path: 'supervisor',
        redirect: 'supervisor/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'farmacia-supervisor-index' */'@/views/farmacia/supervisor/List.vue'),
                name: 'farmacia-supervisor-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'farmacia-supervisor' */ '@/views/farmacia/supervisor/Form.vue'),
                name: 'farmacia-supervisor-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'farmacia-supervisor' */ '@/views/farmacia/supervisor/Form.vue'),
                name: 'farmacia-supervisor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]